import { useCombobox, type UseComboboxStateChange } from "downshift";

import { type Organization } from "../../../lib/types/types";

export const handleStateChange = (
  changes: UseComboboxStateChange<Organization>,
  onChange: Function,
  opts: {
    openOrgSearchEnabled: boolean;
    _searchOverlayEnabled?: boolean;
  },
) => {
  if (changes.type === useCombobox.stateChangeTypes.FunctionSelectItem) {
    const { selectedItem } = changes;
    onChange(selectedItem);
  } else if (changes.type === useCombobox.stateChangeTypes.InputBlur) {
    if (!opts.openOrgSearchEnabled && !opts._searchOverlayEnabled) {
      onChange({
        id: undefined,
        name: "",
      });
    }
  }
};
